<div
  class="modal fade"
  bsModal
  #simbologia_modal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title pull-left text-primary">
          {{ "ayuda.simbologia.titulo" | translate }}
        </h5>
        <button
          (click)="simbologia_modal.hide()"
          class="close pull-right"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p-accordion multiple="true">
              <ng-container *ngFor="let symbol of simbolos">
                <p-accordionTab>
                  <ng-template pTemplate="header">
                    <i class="{{ symbol.icon }} fa-fw"> </i
                    >{{ symbol.titulo | translate }}
                  </ng-template>

                  <div class="{{ symbol.subs != null ? 'margin-bottom' : '' }}">
                    {{ symbol.glosa | translate }}
                  </div>
                  <ng-container *ngIf="symbol.subs != null">
                    <p-accordion multiple="true">
                      <ng-container *ngFor="let subsymbol of symbol.subs">
                        <p-accordionTab>
                          <ng-template pTemplate="header">
                            <i class="{{ subsymbol.icon }} fa-fw"> </i
                            >{{ subsymbol.titulo | translate }}
                          </ng-template>
                          {{ subsymbol.glosa | translate }}
                        </p-accordionTab>
                      </ng-container>
                    </p-accordion>
                  </ng-container>
                </p-accordionTab>
              </ng-container>
            </p-accordion>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <p-button
          styleClass="p-button-sm"
          pRipple
          label="{{ 'button.cerrar' | translate }}"
          (click)="simbologia_modal.hide()"
          icon="pi pi-times"
        ></p-button>
      </div>
    </div>
  </div>
</div>
